import { lazy, Suspense } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

const ServicesPage = lazy(() => import("./pages/Services"));
const DomainHostingPage = lazy(() => import("./pages/DomainHosting"));
const GoDaddyPage = lazy(() => import("./pages/GoDaddy"));
const SmmPanelPage = lazy(() => import("./pages/SmmPanel"));
const AiToolsPage = lazy(() => import("./pages/AiTools"));
const GoogleAiProPage = lazy(() => import("./pages/GoogleAiPro"));
const AcademyPage = lazy(() => import("./pages/Academy"));
const PaypalPage = lazy(() => import("./pages/Paypal"));

const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const WifiHackDevicePage = lazy(() => import("./pages/WifiHackDevice"));
const NetflixGiveawayPage = lazy(() => import("./pages/NetflixGiveaway"));
const VeoBunnyFlowPage = lazy(() => import("./pages/VeoBunnyFlow"));
const TradingViewPage = lazy(() => import("./pages/TradingView"));
const CapcutProPage = lazy(() => import("./pages/CapcutPro"));


const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Suspense fallback={null}>
            <Toaster />
            <Sonner />
          </Suspense>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/services" element={<Suspense fallback={null}><ServicesPage /></Suspense>} />
              <Route path="/domain-hosting" element={<Suspense fallback={null}><DomainHostingPage /></Suspense>} />
              <Route path="/godaddy" element={<Suspense fallback={null}><GoDaddyPage /></Suspense>} />
              <Route path="/smm-panel" element={<Suspense fallback={null}><SmmPanelPage /></Suspense>} />
              <Route path="/ai-tools" element={<Suspense fallback={null}><AiToolsPage /></Suspense>} />
              <Route path="/google-ai-pro" element={<Suspense fallback={null}><GoogleAiProPage /></Suspense>} />
              <Route path="/academy" element={<Suspense fallback={null}><AcademyPage /></Suspense>} />
              <Route path="/paypal" element={<Suspense fallback={null}><PaypalPage /></Suspense>} />
              <Route path="/wifi-hack-device" element={<Suspense fallback={null}><WifiHackDevicePage /></Suspense>} />
              <Route path="/netflix-giveaway" element={<Suspense fallback={null}><NetflixGiveawayPage /></Suspense>} />
              <Route path="/veo-bunny-flow" element={<Suspense fallback={null}><VeoBunnyFlowPage /></Suspense>} />
              <Route path="/trading-view" element={<Suspense fallback={null}><TradingViewPage /></Suspense>} />
              <Route path="/capcut-pro" element={<Suspense fallback={null}><CapcutProPage /></Suspense>} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </HelmetProvider>
);

export default App;
